import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { EventTicketHeader, TimesIcon } from 'components'
import Modal from 'components/AuthModal/components/Modal'
import Overlay from 'components/AuthModal/components/Overlay'
import { OVERLAY } from 'components/AuthModal/styles'
import TicketBox from './TicketBox'

const TicketModal = ({ show, event, onReserve, onClose, user, history }) => {
  const [autoFocus, setAutoFocus] = useState(false)

  return (
    <Overlay show={show} className={OVERLAY} preventEscBackdropClose={true} autoFocus={autoFocus}>
      <Modal
        innerClassName="bg-midnightBlack rounded-t-3xl overflow-y-scroll md:rounded-xl"
        onAnimationComplete={() => setAutoFocus(true)}
      >
        <div className="relative w-full">
          <div className="hidden text-white flex-col w-full items-center text-center mb-5 md:flex">
            <div
              className="mb-5 bg-cover w-full flex justify-center pt-16 relative"
              style={{
                backgroundImage: `url(${event.image})`,
              }}
            >
              <div
                className="absolute w-full inset-0"
                style={{
                  background:
                    'linear-gradient(180deg, rgba(16, 19, 22, 0.0001) 0%, #181B1F 99.26%)',
                }}
              />
              <div className="text-4xl font-ownersWide text-center w-72 relative">
                {event.title}
              </div>
            </div>
            <div className="text-base opacity-30 w-96 mx-8">
              Redeem your invite by reserving a ticket to this event. Once you attend your first
              event you’ll unluck access to more events.
            </div>
          </div>
          <button
            className="absolute top-4 right-4 bg-black rounded-full flex items-center justify-center w-7 h-7 z-10 md:bg-opacity-20"
            onClick={onClose}
          >
            <TimesIcon className="w-3 text-white" />
          </button>
          <div className="px-4 py-5 md:px-6">
            <div className="block md:hidden">
              <div className="text-white text-opacity-50 text-center text-base mb-5">Reserve</div>
              <div className="mb-10">
                <EventTicketHeader event={event} />
              </div>
            </div>
            <TicketBox user={user} event={event} onReserve={onReserve} history={history} />
          </div>
        </div>
      </Modal>
    </Overlay>
  )
}

TicketModal.propTypes = {
  show: PropTypes.bool,
  onReserve: PropTypes.func,
  onClose: PropTypes.func,
  history: PropTypes.object,
  user: PropTypes.object,
  event: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    status: PropTypes.string,
    location: PropTypes.string,
    image: PropTypes.string,
  }),
}

export default TicketModal
